import { render, staticRenderFns } from "./new.text-blocks.page.vue?vue&type=template&id=45ff030b&"
import script from "./new.text-blocks.page.vue?vue&type=script&lang=js&"
export * from "./new.text-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports